import { render } from "./InOnLaysNot.vue?vue&type=template&id=2b8dfc12"
import script from "./InOnLaysNot.vue?vue&type=script&lang=js"
export * from "./InOnLaysNot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__